const NIP = /^\d{10}$/
export default NIP